/* stylelint-disable scss/dollar-variable-colon-space-after */
/* stylelint-disable scss/dollar-variable-colon-space-after */
/* stylelint-disable scss/dollar-variable-colon-space-after */
.display1 {
  font-size: 48px;
  font-weight: normal;
  line-height: 125%;
}
.display1.bold,
.display1 .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .display1 {
    font-size: 30px;
    line-height: 150%;
  }
}

.display2 {
  font-size: 40px;
  font-weight: normal;
  line-height: 125%;
}
.display2.bold,
.display2 .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .display2 {
    font-size: 27px;
    line-height: 150%;
  }
}

.display3 {
  font-size: 36px;
  font-weight: normal;
  line-height: 125%;
}
.display3.bold,
.display3 .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .display3 {
    font-size: 24px;
    line-height: 150%;
  }
}

.heading1 {
  font-size: 24px;
  font-weight: normal;
  line-height: 150%;
}
.heading1.bold,
.heading1 .bold {
  font-weight: 600;
}

.heading2 {
  font-size: 20px;
  font-weight: normal;
  line-height: 150%;
}
.heading2.bold,
.heading2 .bold {
  font-weight: 600;
}

.heading3 {
  font-size: 18px;
  font-weight: normal;
  line-height: 150%;
}
.heading3.bold,
.heading3 .bold {
  font-weight: 600;
}

.heading4 {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
}
.heading4.bold,
.heading4 .bold {
  font-weight: 600;
}

.subheading1 {
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
}

.subheading2 {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
}

.subheading3 {
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
}

.body1 {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
}
.body1.bold,
.body1 .bold {
  font-weight: 600;
}

.body2 {
  font-size: 14px;
  font-weight: normal;
  line-height: 150%;
}
.body2.bold,
.body2 .bold {
  font-weight: 600;
}

.body3 {
  font-family: "Red Hat Text", "Helvetica", sans-serif;
  font-size: 12px;
  font-weight: normal;
  line-height: 150%;
}
.body3.bold,
.body3 .bold {
  font-weight: 600;
}

.button1 {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 100%;
  text-transform: uppercase;
}

.button2 {
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 100%;
  text-transform: uppercase;
}

.link1 {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
  text-decoration-line: underline;
}
.link1.bold,
.link1 .bold {
  font-weight: 600;
}

.link2 {
  font-size: 14px;
  font-weight: normal;
  line-height: 150%;
  text-decoration-line: underline;
}
.link2.bold,
.link2 .bold {
  font-weight: 600;
}

.link3 {
  font-size: 12px;
  font-weight: normal;
  line-height: 150%;
  text-decoration-line: underline;
}
.link3.bold,
.link3 .bold {
  font-weight: 600;
}

.small-label1 {
  font-size: 12px;
  font-weight: bold;
  line-height: 100%;
  text-transform: uppercase;
}

.small-label2 {
  font-size: 10px;
  font-weight: bold;
  line-height: 100%;
  text-transform: uppercase;
}

.cursor-pointer {
  cursor: pointer;
}

.underline {
  text-decoration: underline;
}

.uppercase {
  text-transform: uppercase;
}

.lowercase {
  text-transform: lowercase;
}

.no-text-transform {
  text-transform: none;
}

.gray {
  color: #a6a6a6;
}

.light-gray {
  color: #ccc;
}

.lighter-gray {
  color: #eaeaea;
}

.lightest-gray {
  color: #f5f5f5;
}

.dark-gray {
  color: #767676;
}

.darker-gray {
  color: #606060;
}

.darkest-gray {
  color: #404040;
}

.purple {
  color: #5b1dc2;
}

.dark-purple {
  color: #4b18a1;
}

.white {
  color: #fff;
}

.black {
  color: #000;
}

.red {
  color: #fd868c;
}

.darker-red {
  color: #d43838;
}

.dark-orange {
  color: #ff8313;
}

.center {
  text-align: center;
}

.right {
  text-align: right;
}

.normal {
  font-weight: normal;
}

.container {
  background-color: #fff;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.header {
  border-bottom: 1px solid #eaeaea;
  padding: 16px;
  font-size: 20px;
  font-weight: normal;
  line-height: 150%;
}
.header.bold,
.header .bold {
  font-weight: 600;
}
.header:first-child {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.header:last-child {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
.header:only-child {
  border-radius: 8px;
}

.content {
  background-color: #fff;
}
.content:not(:last-child) {
  border-bottom: 1px solid #eaeaea;
}
.content {
  flex: 1;
}
.content:first-child {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.content:last-child {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
.content:only-child {
  border-radius: 8px;
}

.footer {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  padding: 16px;
}
.footer:first-child {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.footer:only-child {
  border-radius: 8px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */